/**
 * Whether the draft already on screen is the one being asked for.
 *
 * All four conditions are load-bearing:
 *
 * - there has to *be* a draft in view, and the route has to be a draft route —
 *   a thread route's draft is a different thing;
 * - it has to belong to the same logical project, or "new thread in project A"
 *   would silently reuse project B's draft;
 * - and it must not be promoted. A promoted draft has a real thread behind it,
 *   so adopting one would write new context onto work that has already started.
 */
export function canAdoptCurrentDraft(input: {
  readonly latestActiveDraft: {
    readonly logicalProjectKey?: string;
    readonly promotedTo?: unknown;
  } | null;
  readonly routeTargetKind: string | undefined;
  readonly logicalProjectKey: string;
}): boolean {
  const draft = input.latestActiveDraft;
  if (!draft) return false;
  if (input.routeTargetKind !== "draft") return false;
  if (draft.logicalProjectKey !== input.logicalProjectKey) return false;
  return draft.promotedTo == null;
}
